import React, { FC, useMemo, useState } from 'react';

import { DatePicker } from '@column/ui';

import { TableFilterTrigger } from './TableFilterTrigger';

interface TableMonthFilterProps {
  /** Selected month as `YYYY-MM`. */
  value?: string;
  onChange: (value: string | undefined) => void;
  label?: string;
  fromMonth?: Date;
}

const parseMonth = (value?: string) => {
  const [year, month] = value?.split('-').map(Number) ?? [];
  return year && month ? new Date(year, month - 1, 1) : undefined;
};

const toValue = (month: Date) => `${month.getFullYear()}-${String(month.getMonth() + 1).padStart(2, '0')}`;

export const TableMonthFilter: FC<TableMonthFilterProps> = ({ value, onChange, label = 'Date', fromMonth }) => {
  const [open, setOpen] = useState(false);
  const disabledDays = useMemo(
    () => [...(fromMonth ? [{ before: fromMonth }] : []), { after: new Date() }],
    [fromMonth, open]
  );
  const selected = parseMonth(value);

  return (
    <DatePicker
      variant="month"
      value={selected}
      onValueChange={(month) => onChange(month ? toValue(month) : undefined)}
      disabledDays={disabledDays}
      clearable
      align="start"
      onOpenChange={setOpen}
    >
      <TableFilterTrigger isActive={Boolean(selected)} isOpen={open}>
        {selected ? selected.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : label}
      </TableFilterTrigger>
    </DatePicker>
  );
};
